@if (!isPartner) {
  <form [formGroup]="form">
    <div class="row card">
      <div class="card-header heading pad-horizontal-20">
        <span class="icon-auto margin-right-10"></span>
        <span data-cy="outOfPocketCoveragesHeader"
          >{{ sectionHeader }} {{ vehicleRiskDescription }}</span
        >
      </div>
      <div class="pad-top-50 pad-bottom-10 pad-left-5">
        @for (coverage of coverages; track coverage) {
          <div
            class="row pad-horizontal-10 sm-pad-horizontal-50 pad-vertical-10 sm-pad-vertical-30"
          >
            @if (!coverage?.isCheckbox) {
              <div>
                <div class="column twelve md-six pad-left-40 pad-right-20">
                  <h2 class="coverage-heading">{{ coverage.coverageDescription }}</h2>
                  <p>{{ coverage.coverageSubHeading }}</p>
                  @if (coverage?.kydTPMPackageCoverageInfo) {
                    <p class="margin-top-10">
                      {{ coverage.kydTPMPackageCoverageInfo }}
                    </p>
                  }
                </div>
                <div
                  class="column twelve sm-six pad-horizontal-5 pad-vertical-10 sm-pad-vertical-30"
                >
                  <ds-form-control-container
                    [labelText]="coverage.coverageDescription"
                    [control]="form.controls[getControlName(coverage)]"
                  >
                    <select
                      class="icon fill"
                      [disabled]="
                        (coverage.coverageCode === 'PALimitedCollisionCov_af' &&
                          !canEnablePALimitedCollisionCov_af()) ||
                        ('PAComprehensiveCov' && !canEnablePAComprehensiveCov())
                      "
                      [formControlName]="getControlName(coverage)"
                      [attr.data-cy]="coverage.coverageDescription + 'Select' | camelCase"
                    >
                      <option value="" disabled selected></option>
                      @for (option of coverage.options; track option) {
                        <option [value]="option">
                          {{ option | coverageCurrencyUSD: coverage.coverageCode : state }}
                        </option>
                      }
                    </select>
                    <span class="icon-chevron-down"></span>
                  </ds-form-control-container>
                  @if (canShowNoDeductible(coverage)) {
                    <span>No Deductible</span>
                  }
                  @if (
                    coverage.extraOptions &&
                    coverage.extraOptions.length > 0 &&
                    canShowExtraOption(coverage) &&
                    canShowComprehensiveOption(coverage)
                  ) {
                    <ds-form-control-container
                      [labelText]="coverage.coverageExtraDescription"
                      [control]="
                        form.controls[
                          coverage.coverageCode + ':' + coverage.coverageExtraDescription
                        ]
                      "
                    >
                      <select
                        class="icon fill"
                        [formControlName]="
                          coverage.coverageCode + ':' + coverage.coverageExtraDescription
                        "
                        [attr.data-cy]="coverage.coverageExtraDescription + 'Select' | camelCase"
                      >
                        <option value="" disabled selected></option>
                        @for (option of getExtraOptions(coverage); track option) {
                          <option [value]="option">
                            {{ option | coverageCurrencyUSD: coverage.coverageCode : state }}
                          </option>
                        }
                      </select>
                      <span class="icon-chevron-down"></span>
                    </ds-form-control-container>
                  }
                  @if (
                    (coverage?.deductibleDictionary)[form.controls[coverage.coverageCode]?.value]
                  ) {
                    <p class="caption pad-top-10">
                      @if (
                        (coverage?.deductibleDictionary)[
                          form.controls[coverage.coverageCode]?.value
                        ] !== '0'
                      ) {
                        <span>{{
                          coverage.deductibleDictionary[form.controls[coverage.coverageCode]?.value]
                        }}</span>
                      }
                      @if (
                        (coverage?.deductibleDictionary)[
                          form.controls[coverage.coverageCode]?.value
                        ] === '0'
                      ) {
                        <span>
                          {{
                            coverage.deductibleDictionary[
                              form.controls[coverage.coverageCode]?.value
                            ] | currencyUSD: true
                          }}
                          deductible</span
                        >
                      }
                    </p>
                  }
                  @for (coverageHelp of coverage.coverageHelpTextList; track coverageHelp) {
                    <p class="caption pad-top-10">
                      {{ coverageHelp }}
                    </p>
                  }
                </div>
              </div>
            }
            @if (coverage?.isCheckbox) {
              <div>
                <div class="column ten pad-left-40 pad-right-20">
                  <h2 class="coverage-heading">{{ coverage.coverageDescription }}</h2>
                  <p>{{ coverage.coverageSubHeading }}</p>
                  @if (
                    UMPDStateCode === 'IL' &&
                    coverage?.selectedValue !== '' &&
                    coverage?.coverageDescription === 'Uninsured Motorist - Property Damage'
                  ) {
                    <p>$15,000/accident, $250 deductible</p>
                  }
                </div>
                <div
                  class="column two md-pad-left-20 pad-top-60 md-pad-top-20"
                  (click)="toggleCtrl(coverage.coverageCode)"
                >
                  <input
                    class="checkbox"
                    type="checkbox"
                    [id]="coverage.coverageCode"
                    [formControlName]="coverage.coverageCode"
                    (change)="toggleCtrl(coverage.coverageCode)"
                  />
                  <label class="checkbox-label"></label>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>
}

@if (isPartner) {
  <form [formGroup]="form">
    <div class="row card">
      <div class="card-header heading pad-horizontal-20">
        <span class="icon-binoculars margin-right-10"></span>
        <span data-cy="outOfPocketCoveragesHeader">{{ sectionHeader }}</span>
      </div>
      <div class="pad-top-10 pad-bottom-10 pad-left-5">
        @for (coverage of partnerCoverages | transformcoverages; track coverage) {
          <div
            class="row pad-horizontal-10 sm-pad-horizontal-50 pad-vertical-10 sm-pad-vertical-30"
          >
            @if (coverage.hasTerms && coverage?.publicID !== 'PAEmergencyRoadServiceCov_af') {
              <div>
                <div class="column twelve md-six pad-left-40 pad-right-20">
                  <h2 class="coverage-heading">{{ coverage.name }}</h2>
                  <p>{{ coverage.description }}</p>
                  @if (coverage?.kydTPMPackageCoverageInfo) {
                    <p class="margin-top-10">
                      {{ coverage.kydTPMPackageCoverageInfo }}
                    </p>
                  }
                </div>
                <div
                  class="select-container column twelve sm-six pad-horizontal-5 pad-vertical-10 sm-pad-vertical-30"
                >
                  <!-- TEJA: dont use coverage.controls, use coverage.terms -->
                  @for (term of coverage.terms; track term) {
                    <ds-form-control-container
                      class="select-form-container"
                      [labelText]="term.name"
                      [control]="form.controls[coverage?.publicID + term.name]"
                    >
                      <select
                        [ngClass]="
                          (colisionCov && term.name === waiveOfDeductable) ||
                          (compresiveCov && term.name === glassCoverage) ||
                          (rentReamb && term.name === optionofCoverageTerm)
                            ? 'disableddrp'
                            : ''
                        "
                        class="icon fill"
                        [formControlName]="coverage.publicID + term.name"
                        [attr.data-cy]="term.name + 'Select' | camelCase"
                        (change)="
                          updateCoverage.emit({
                            selectedId: this.selectedId,
                            coverage: coverage,
                            term: term,
                            option: $event.target.value
                          });
                          optionEnabledDisabled($event.target.value, coverage.publicID, term.name)
                        "
                      >
                        @if (coverage.publicID === 'PARentalCov' && state === 'VA') {
                          <option value="Not Selected">Not Selected</option>
                        }
                        @for (
                          option of term.options
                            | removeRejected
                            | removeNoCoverage: state : removeNoCoverageStates : coverage.publicID;
                          track option
                        ) {
                          <option [value]="option.name">
                            {{ option.name | coverageCurrencyUSD: coverage.publicID }}
                          </option>
                        }
                      </select>
                      <span class="icon-chevron-down"></span>
                    </ds-form-control-container>
                  }
                  <!-- <p *ngIf="hasDeductible(coverage)" class="caption pad-top-10">
                        <span>{{ getDeductible(coverage) }}</span>
                      </p> -->
                  @if (coverage.publicID === 'PARentalCov' && state === stateCode) {
                    <ds-clicktip-icon
                      ariaDescribedBy="showComprehensiveInfo"
                      [clicktipRef]="comprehensiveClicktip"
                      class="help-text"
                    >
                    </ds-clicktip-icon>
                  }
                  @for (coverageHelp of coverage?.coverageHelpTextList; track coverageHelp) {
                    <p class="caption pad-top-10">
                      {{ coverageHelp }}
                    </p>
                  }
                </div>
              </div>
            }
            <div class="row">
              <div class="column twelve">
                <ds-clicktip
                  #comprehensiveClicktip
                  label="showComprehensiveInfo"
                  title="What is Option ?"
                  [text]="policyDescription"
                  class="column twelve pad-left-40 pad-right-20 policy-text"
                ></ds-clicktip>
              </div>
            </div>
            @if (!coverage?.hasTerms || coverage?.publicID === 'PAEmergencyRoadServiceCov_af') {
              <div>
                <div class="column ten pad-left-40 pad-right-20">
                  <h2 class="coverage-heading">{{ coverage.name }}</h2>
                  <p>{{ coverage.description }}</p>
                </div>
                <div
                  class="column two md-pad-left-20 pad-top-60 md-pad-top-20"
                  [ngClass]="
                    coverage?.publicID === 'PAEmergencyRoadServiceCov_af' && coverage?.isDisabled
                      ? 'disabled'
                      : ''
                  "
                >
                  <input
                    class="checkbox"
                    type="checkbox"
                    [id]="coverage.publicID"
                    [formControlName]="coverage.publicID"
                    (change)="update(coverage, $event.target.value)"
                  />
                  <label
                    class="checkbox-label"
                    [attr.for]="coverage.publicID"
                    [ngClass]="
                      coverage?.publicID === 'PAEmergencyRoadServiceCov_af' && coverage?.isDisabled
                        ? 'checkbox-labeldisabled'
                        : ''
                    "
                  ></label>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>
}
